import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { SvgIconComponent } from 'src/app/ui/svg-icon/svg-icon.component';
import { MatDialog } from '@angular/material/dialog';
import { GiftBannerDetailsComponent } from './gift-banner-details/gift-banner-details.component';
import { IPriceBookViewDTO } from 'src/app/features/pricebook/models/pricebook.model';
import { PricebookService } from 'src/app/features/pricebook/services/pricebook.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-gift-banner',
  standalone: true,
  imports: [NgIf, SvgIconComponent, TranslateModule],
  templateUrl: './gift-banner.component.html',
  styleUrls: ['./gift-banner.component.scss'],
})
export class GiftBannerComponent {
  @Input() gifts: IPriceBookViewDTO[] = [];
  @Input() amount: number | null = null;
  @Input() quantity: number | null = null;
  @Input() flat: boolean = false;

  constructor(
    private dialog: MatDialog,
    private pricebookService: PricebookService,
  ) {}

  ngOnInit() {}

  getGiftMessage(gift: IPriceBookViewDTO): { pricebook: string; message: string } {
    return this.pricebookService.getRewardMessage(gift, this.amount, this.quantity);
  }

  showDetails() {
    this.dialog.open(GiftBannerDetailsComponent, {
      data: {
        gifts: this.gifts,
        amount: this.amount,
        quantity: this.quantity,
      },
    });
  }
}
